// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2oQZ8","colCheckbox":"styles_colCheckbox__3GQ0_"};